import React from 'react';
import { getCompanyLogoSrcset, getCompanyLogoDefaultSrc } from '../../../../../utils/company/get-company-logo-url';
import { fixMojibake } from '../../../../../utils/text/fix-mojibake';

const DEFAULT_LOGO_SRC = '/company-logo-default.svg';

export interface JobHeaderProps {
  title?: string;
  normalisedTitle?: string | null;
  companyId?: string | null;
  location?: string | string[];
  isTyomarkkinatori?: boolean;
  onLogoError?: (companyId: string) => (e: React.SyntheticEvent<HTMLImageElement, Event>) => void;
}

function defaultLogoErrorHandler(e: React.SyntheticEvent<HTMLImageElement, Event>) {
  const img = e.target as HTMLImageElement;
  img.srcset = '';
  img.src = DEFAULT_LOGO_SRC;
}

export const JobHeader: React.FC<JobHeaderProps> = ({
  title,
  normalisedTitle,
  companyId,
  location,
  isTyomarkkinatori = false,
  onLogoError,
}) => {
  if (!title) return null;

  const primaryLocation = Array.isArray(location) 
    ? (location[0] || '') 
    : (location || '');
  const h1Text = [title, companyId, primaryLocation]
    .filter(Boolean)
    .join(' - ');

  return (
    <div className="flex flex-col mb-6 gap-2">
      <div className="flex items-center gap-3">
        {/* Small Company Logo */}
        {companyId && (
          <div className="flex-shrink-0">
            <div 
              className={`w-10 h-10 flex items-center justify-center ${isTyomarkkinatori ? '' : 'bg-white dark:bg-gray-800 border border-gray-200/60 dark:border-gray-700/60'} shadow-sm rounded-xl overflow-hidden p-1`}
              style={isTyomarkkinatori ? { backgroundColor: '#6B46C1' } : {}}
            >
              <img
                className="object-contain w-full h-full"
                alt={`${companyId} company logo`}
                src={getCompanyLogoDefaultSrc(companyId, isTyomarkkinatori)}
                srcSet={getCompanyLogoSrcset(companyId, isTyomarkkinatori)}
                sizes="40px"
                onError={onLogoError ? onLogoError(companyId) : defaultLogoErrorHandler}
                loading="eager"
                decoding="async"
              />
            </div>
          </div>
        )}
        <div className="flex-1 min-w-0">
          <h1 className="truncate font-bold text-xl text-gray-900 dark:text-white">
            {fixMojibake(h1Text)}
          </h1>
          {normalisedTitle && normalisedTitle !== title && (
            <h2 className="truncate text-sm text-gray-500 dark:text-gray-400 font-normal italic mt-1" title={fixMojibake(normalisedTitle)}>
              {fixMojibake(normalisedTitle)}
            </h2>
          )}
        </div>
      </div>
    </div>
  );
};
